import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import './App.css';
// Components
import Navbar from './components/Navbar';
// import AIChatBot from './components/AIChatBot';
import { Component as CursorFollower } from './components/ui/cursor-follower';
// Containers or pages
const Home = lazy(() => import('./containers/Home'));
const About = lazy(() => import('./containers/About'));
const Projects = lazy(() => import('./containers/Projects'));
const Blogs = lazy(() => import('./containers/Blogs'));
const Contact = lazy(() => import('./containers/Contact'));
const Snippets = lazy(() => import('./containers/Snippets'));
const Publications = lazy(() => import('./containers/Publications'));
const Resume = lazy(() => import('./containers/Resume'));

function App() {
  return (
    <div className="App">
      <Router>
        <CursorFollower />
        <Navbar />
        <AnimatePresence mode="wait">
          <Suspense fallback={<div className="text-center text-white py-20">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/snippets" element={<Snippets />} />
              <Route path="/publications" element={<Publications />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/resume" element={<Resume />} />
            </Routes>
          </Suspense>
        </AnimatePresence>
        {/* <AIChatBot /> */}
      </Router>
    </div>
  );
}

export default App;